import { ChangeDetectionStrategy, Component, input } from '@angular/core';

// Marca de VendIA — reemplaza la "V" de texto plano quemada a mano en sidebar/header/auth-layout
// (3 copias con el mismo div bg-primary-container + letra) por un vector propio: una "V" trazada
// (no texto, así no depende de peso/línea base de la fuente y se ve nítida en cualquier tamaño,
// incluido el favicon de 16px) + un destello de 4 puntas que referencia el "IA" del nombre.
// Mismos tokens de marca que ya usa el resto de la app (primary #260054, secondary-fixed #62ff96),
// no colores nuevos inventados. El SVG del favicon (public/favicon.svg) es una copia física de
// este mismo path — si se cambia el diseño acá, actualizar ese archivo también.
@Component({
  selector: 'app-logo-mark',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg [attr.width]="size()" [attr.height]="size()" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="32" height="32" rx="8" fill="#260054" />
      <path d="M8 9 L16 23 L24 9" stroke="#62ff96" stroke-width="4.25" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M24.5 3.5 L26 5.5 L28 7 L26 8.5 L24.5 10.5 L23 8.5 L21 7 L23 5.5 Z" fill="#ffffff" />
    </svg>
  `,
})
export class LogoMarkComponent {
  readonly size = input(36);
}
